export default class Febuilding {
    /**
     * @type {string}
     * @memberof Febuilding
     * @name 楼宇ID
     */
    public buildingId: string;
    /**
     * @type {string}
     * @memberof Febuilding
     * @name 楼宇NO
     */
    public no: string;
    /**
     * @type {string}
     * @memberof Febuilding
     * @name 楼宇名称
     */
    public name: string;
    /**
     * @type {string}
     * @memberof Febuilding
     * @name 楼宇类型
     */
    public type: string;
    /**
     * @type {string}
     * @memberof Febuilding
     * @name 楼宇类型名称
     */
    public typeName: string;
    /**
     * @type {string}
     * @memberof Febuilding
     * @name 校区ID
     */
    public campusId: string;
    /**
     * @type {string}
     * @memberof Febuilding
     * @name 出口距离
     */
    public exitDistance: string;
    /**
     * @type {string}
     * @memberof Febuilding
     * @name 楼宇层数
     */
    public floorSize: string;
    /**
     * @type {string}
     * @memberof Febuilding
     * @name 楼宇坐标
     */
    public positionInPic: string;
    /**
     * @type {string}
     * @memberof Febuilding
     * @name 楼宇房间数
     */
    public roomNums: string;
    constructor({
        buildingId = '',
        no = '',
        name = '',
        type = '',
        typeName = '',
        campusId = '',
        exitDistance = '',
        floorSize = '',
        positionInPic = '',
        roomNums = ''
    } = {}) {
        this.buildingId = buildingId,
        this.no = no,
        this.name = name,
        this.type = type,
        this.typeName = typeName,
        this.campusId = campusId,
        this.exitDistance = exitDistance,
        this.floorSize = floorSize,
        this.positionInPic = positionInPic,
        this.roomNums = roomNums
    }
}